import React, {
  DetailedHTMLProps,
  forwardRef,
  TextareaHTMLAttributes,
  useImperativeHandle,
  useMemo,
  useRef,
} from "react";
import { v4 as uuid } from "uuid";

import { useAutoSize } from "../../../hooks/useAutoSize";
import InputLabel from "../InputLabel";
import "./styles.scss";

export interface TextAreaProps
  extends DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  value: string;
  label?: string;
  autoSize?: boolean;
  minHeight?: number;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ id, className, label, value, autoSize = false, minHeight, rows, ...textAreaProps }, ref) => {
    const elementId = useMemo(() => id ?? uuid(), [id]);
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useImperativeHandle(ref, () => textareaRef.current!);

    useAutoSize(autoSize, textareaRef, minHeight, value);

    return (
      <div className={`c-textarea ${className ?? ""}`}>
        {label ? <InputLabel htmlFor={elementId}>{label}</InputLabel> : null}
        <textarea
          ref={textareaRef}
          {...textAreaProps}
          className="c-textarea__input"
          id={elementId}
          rows={autoSize ? undefined : rows}
          value={value}
        />
      </div>
    );
  },
);

export default TextArea;
